<template>
  <div class="col col-12 col-md-6">
    <h4 class="text-primary" v-dynamic-content:faq_title></h4>
    <section class="mt-6">
      <div v-if="faqs">
        <div v-for="faq of faqs" :key="faq.id" class="question mb-3">
          <div
            class="collapse-item d-flex justify-items-between align-items-center"
            v-b-toggle="faq.id"
          >
            <p class="font-weight-bold pl-3 mb-0" v-dynamic-content="{ rawText: faq.question }"></p>
          </div>
          <b-collapse :id="faq.id" class="pl-6 mt-2" accordion="faq">
            <p v-dynamic-content="{ rawText: faq.answer }"></p>
          </b-collapse>
        </div>
      </div>
      <div v-else>
        <loader></loader>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: ['page'],
  name: 'FAQ',
  computed: {
    content() {
      return this.$store.state.data.content
    },
    faqs() {
      const faqs = this.$store.getters.faqs || []
      return faqs.filter((faq) => faq.pages && faq.pages.includes(this.page))
    },
  },
}
</script>
